import { PropsWithChildren, ReactElement } from 'react';
import { Button, Modal } from 'reactstrap';

interface Props<T> {
  isOpen: boolean;
  onToggle: () => void;
  onConfirmation: (payload: T) => Promise<void>;
  bodyText: string;
  confirmationText: string;
  abortText: string;
  titleText: string;
  payload?: T;
}

const BasicModal: React.FC<Props<any>> = ({
  abortText,
  bodyText,
  confirmationText,
  isOpen,
  onConfirmation,
  onToggle,
  titleText,
  payload,
}) => {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          {titleText}
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <p>{bodyText}</p>
      </div>
      <div className="modal-footer">
        <Button
          color="danger"
          type="button"
          onClick={() => onConfirmation(payload)}
        >
          {confirmationText}
        </Button>
        <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          {abortText}
        </Button>
      </div>
    </Modal>
  );
};

export default BasicModal;
